import React from 'react'
import './navbar.css'
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import About from '../../Pages/About/About';
import Collections from "../../Pages/Collections/Collections"
import Blog from "../../Pages/nftdetail/nftdetail";
import How_it_works from "../../Pages/How_it_works/How_it_works";
import Marketplace from '../../Pages/Marketplace/Marketplace';
import NFT_Final_full from '../../Pages/NTF_Final/NFT_Final_full/NFT_Final_full';
import Collections_sub from '../../Pages/collections-sub/Collections_sub';
import Navbar from './Navbar';
import Profile_pg from '../../Pages/Profile/Profile_pg';
import Nft_conformation from '../../Pages/Nft_conformation/Nft_conformation';
import Login from "../../Log-in/Login"
import Signup from '../../Log-in/Sign';
import Wallets from "../../Wallet_pg/Wallet"


function Mobilemenu(props){
     return(props.trigger) ? (
         
         <Router>
             <div id="m-menu" className="m-menu-wrapper">
             <div>
                 <button className="m-menu-close" onClick={()=>props.setTrigger(false)}><i className="fas fa-times"></i></button>
             </div>
             <div className="m-menu-container">
                 <ul>
                     <li className="m-menu-items"><Link to="/collections">COLLECTIONS</Link></li>
                     <li className="m-menu-items"><Link to="/marketplace">MARKETPLACE</Link></li>
                     <li className="m-menu-items"><Link to="/how it works">HOW IT WORKS</Link></li>
                     <li className="m-menu-items"><Link to="/blog">BLOG</Link></li>
                     <li className="m-menu-items"><Link to="/about">ABOUT</Link></li>
                 </ul>
             </div>
             <div className="m-menu-btngrp">
                 <button className="m-menu-login"><Link to="/login">login</Link></button>
                 <button className="m-menu-signup"><Link to="/signup">signup</Link></button>
             </div>
         </div>


         <Switch>
             <Route exact path="/signup">
                 <Signup />

             </Route>


             <Route exact path="/login">
                 <Login />
             </Route>
             <Route exact path="/wallet">
                 <Wallets />

             </Route>









             <div>
                 <Navbar />



                
                

                 <Route exact path="/about">
                     <About></About>
                 </Route>
                 <Route exact path="/collections">
                     <Collections></Collections>
                 </Route>
                 <Route exact path="/how it works">
                     <How_it_works />
                 </Route>
                 <Route exact path="/blog">
                     <Blog />
                 </Route>
                 <Route exact path="/marketplace">
                     <Marketplace></Marketplace>
                 </Route>


                 <Route exact path="/wallet">
                     <Wallets />

                 </Route>


                 <Route exact path="/nftfinal">
                     <NFT_Final_full />

                 </Route>
                 <Route exact path="/collections-sub">
                     <Collections_sub />






                 </Route>

                 <Route exact path="/profile">
            <Profile_pg/>






                 </Route>


                 <Route exact path="/nft_conformation">
       <Nft_conformation/>






                 </Route>
                



             </div>





         </Switch>


     </Router>
     ) : "" ;
 }

 export default Mobilemenu